import { render } from "./FilterComponent.vue?vue&type=template&id=bd71efe4&scoped=true"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"

import "./FilterComponent.vue?vue&type=style&index=0&id=bd71efe4&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd71efe4"]])

export default __exports__